module.exports = __webpack_public_path__ + "static/media/telegram.d797ef85.svg";